import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class PutForSellModel extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId, productId }) {
        if (!organizationId || !productId) {
            throw new ArgumentError(`[Model][putforsell][getAll] organizationId is mandatory`);
        }
        return `/ticket/organizations/${organizationId}/products/${productId}/products_sale`;
    }
}
